import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL;
console.log(baseURL)
export const apiClient = axios.create({
    baseURL,
    credentials: false,
});

apiClient.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const getApiErrorMessage = (error, fallback = 'Не удалось выполнить запрос.') => {
    const message = error?.response?.data?.message;

    if (Array.isArray(message)) {
        return message.join(', ');
    }

    return message || fallback;
};

export const getApiAssetUrl = (value, directory) => {
    if (!value) return '';

    const marker = `/${directory}/`;
    const stringValue = String(value);
    const markerIndex = stringValue.lastIndexOf(marker);
    const filename = markerIndex >= 0
        ? stringValue.slice(markerIndex + marker.length)
        : stringValue.split('/').pop();

    const apiOrigin = new URL(baseURL || window.location.origin, window.location.origin).origin;
    return `${apiOrigin}${marker}${encodeURIComponent(decodeURIComponent(filename))}`;
};
